/// <amd-module name="TFS/Admin/Groups/Pivots/ServicePrincipals/Components/ServicePrincipalsPivot" />
import * as React from "react";
import { IPivotProps } from "TFS/Admin/Groups/Common/Contracts";
import { ConnectedServicePrincipalsPivotInitializer } from "TFS/Admin/Groups/Pivots/ServicePrincipals/Components/ServicePrincipalsPivotInitializer";
import { IVssComponentContext, VssComponent } from "VSS/Platform/Layout";

export class ServicePrincipalsPivot extends VssComponent<IPivotProps> {

    constructor(props: IPivotProps, context: IVssComponentContext) {
        super(props, context);
    }

    public render(): JSX.Element {
        return <ConnectedServicePrincipalsPivotInitializer filter={this.props.filter} pageContext={this.context.pageContext} />;
    }
}

VssComponent.register("ms.vss-admin-web.orggroups-service-principals-pivot", ServicePrincipalsPivot);
